import {
  UPDATE_USER_DETAILS,
  TOGGLE_LOADING_USER_DETAILS,
  TOGGLE_EMAIL_LOADING,
  TOGGLE_SENDOTP_LOADING,
} from './user-constants';
import {
  IUpdateUserDetails,
  IToggleLoadingUserDetails,
  IToggleEmailLoading,
  IToggleSendOtpLoading,
} from './user-types';

export function updateUserDetailsAction(
  actionData: IUpdateUserDetails['actionData'],
): IUpdateUserDetails {
  return {
    type: UPDATE_USER_DETAILS,
    actionData,
  };
}

export function updateGccUserDetailsAction(
  actionData: IUpdateUserDetails['actionData'],
): IUpdateUserDetails {
  return {
    type: UPDATE_USER_DETAILS,
    actionData,
  };
}

export function toggleLoadingUserDetailsAction(
  actionData: IToggleLoadingUserDetails['actionData'],
): IToggleLoadingUserDetails {
  return {
    type: TOGGLE_LOADING_USER_DETAILS,
    actionData,
  };
}

export function toggleEmailLoding(
  actionData: IToggleEmailLoading['actionData'],
): IToggleEmailLoading {
  return {
    type: TOGGLE_EMAIL_LOADING,
    actionData,
  };
}

export function toggleSendOtpLoading(
  actionData: IToggleSendOtpLoading['actionData'],
): IToggleSendOtpLoading {
  return {
    type: TOGGLE_SENDOTP_LOADING,
    actionData,
  };
}
